import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const NortheastMap = ({ onStateClick }) => {
	const [selectedState, setSelectedState] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleStateClick = (area) => {
		setSelectedState(area);
		setIsVisible(false);
		setTimeout(() => {
			onStateClick(area);
		}, 500);
		console.log('State Clicked: %s', area);
	};

	return (
		<svg
			id='northeast-region'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1600 1600'
			className={`map ${!isVisible ? 'hidden' : ''}`}>
			<polygon
				id='NJ'
				points='803.25 1436 796.25 1451 797.25 1468 809.25 1488 844.25 1512 867.25 1517 889.25 1516 891.25 1553 902.25 1552 919.25 1503 925.25 1481 941.25 1453 957.25 1410 965.25 1383 965.25 1328.47 957.25 1294 917.25 1292 917.25 1262 929.25 1243 939.25 1234 941.25 1203 829.25 1165 815.25 1187 812.25 1212 798.25 1234 807.25 1257 800 1282.07 809.25 1302 869.25 1356 835.25 1394 827.25 1413 803.25 1436'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NJ'
				className={`polygon ${selectedState === 'NJ' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NJ')}
			/>
			<polygon
				id='NY'
				points='939.25 1234 943.25 1237 946.25 1257 959.25 1263 985.25 1250 1050.25 1214 1091.25 1195 1113.25 1180 1144.25 1149 1116.25 1137 1087.25 1157 1066.25 1168 1038.25 1177 1010.25 1194 976.25 1207 959.25 1217 955.25 1212 967.25 1189 961.25 1172 974.25 1153 965.25 1126.92 947.25 1017 944.25 888 922.25 793 912.25 772 896.25 765 878.25 693 875.25 637 857.25 594 854.25 568 847.36 547.47 677.25 592 641.25 617 611.25 662 596.25 694 588.25 717 551.25 758 552.25 773 564.25 801 574.25 819 572.25 844 550.25 874 523.25 904 491.25 920 471.25 924 372.25 924 320.25 937 284.25 950 266.25 967 267.25 985 281.25 999 292.25 1013 292.25 1043 266.25 1076 238.25 1110 211.3 1134.37 211.3 1188.64 278.25 1177 532.25 1126 720.25 1083 737.25 1084 777.25 1123 796.25 1149.08 829.25 1165 941.25 1203 939.25 1234'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NY'
				className={`polygon ${selectedState === 'NY' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NY')}
			/>
			<polygon
				id='CT'
				points='967.25 1189 988.25 1173 1032.25 1137 1085.25 1113 1160.25 1090.58 1170.46 1084.26 1170.46 1054.26 1147.25 975 1047.25 1002 947.25 1017 965.25 1126.92 974.25 1153 961.25 1172 967.25 1189'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='CT'
				className={`polygon ${selectedState === 'CT' ? 'selected' : ''}`}
				onClick={() => handleStateClick('CT')}
			/>
			<polygon
				id='RI'
				points='1170.46 1084.26 1190.25 1072 1209.25 1057 1209.25 1027.81 1200.25 1013 1209.25 989.84 1183.25 964 1147.25 975 1170.46 1054.26 1170.46 1084.26'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='RI'
				className={`polygon ${selectedState === 'RI' ? 'selected' : ''}`}
				onClick={() => handleStateClick('RI')}
			/>
			<polygon
				id='MA'
				points='1209.25 989.84 1227.25 1006 1244.25 1015 1244.25 1030.45 1258.25 1023 1270.25 1002 1283.25 983 1293.25 989 1293.25 1009.35 1304.25 1010 1330.25 992 1354.25 979 1373.25 965 1373.25 940.78 1364.25 927 1344.25 914 1322.25 909 1357.25 934 1359.25 949 1346.25 962 1322.25 970 1303.25 961 1289.25 946 1274.25 937 1273.25 918 1253.25 904 1221.8 904 1220.25 882 1235.25 860 1253.25 843 1232.25 834 1222.25 814 1206.25 814 1170.25 852 944.65 905.24 947.25 1017 1047.25 1002 1147.25 975 1183.25 964 1209.25 989.84'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='MA'
				className={`polygon ${selectedState === 'MA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('MA')}
			/>
			<polygon
				id='NH'
				points='1222.25 814 1222.25 776 1175.25 726 1175.25 702.7 1084.17 435.62 1078.25 441 1054.25 447 1051.25 498 1051.25 547.47 1061.25 569 1053.25 589 1026.25 619 1026.25 694.26 1013.25 741 1025.25 834 1018.25 854 1028.67 885.41 1170.25 852 1206.25 814 1222.25 814'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NH'
				className={`polygon ${selectedState === 'NH' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NH')}
			/>
			<polygon
				id='VT'
				points='847.36 547.47 921.25 529 989.25 510 1051.25 498 1051.25 547.47 1061.25 569 1053.25 589 1026.25 619 1026.25 694.26 1013.25 741 1025.25 834 1018.25 854 1028.67 885.41 944.65 905.24 944.25 888 922.25 793 912.25 772 896.25 765 878.25 693 875.25 637 857.25 594 854.25 568 847.36 547.47'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='VT'
				className={`polygon ${selectedState === 'VT' ? 'selected' : ''}`}
				onClick={() => handleStateClick('VT')}
			/>
			<polygon
				id='ME'
				points='1084.17 435.62 1175.25 702.7 1175.25 726 1222.25 776 1230.25 746 1241.25 710 1251.25 661 1263.25 632 1276.25 639 1295.65 632 1319.25 618 1325.25 604 1327.25 582 1357.36 582 1359.25 500 1368.25 483 1381.1 483 1386.25 491 1386.25 513 1414.25 513 1414.25 489.26 1429.25 473 1463.25 466 1494.25 434 1526.25 415 1548.25 391 1550.25 374 1535.25 370 1534.25 338 1514.25 327 1487.25 334 1476.25 305 1473.25 271 1435.43 271 1421.25 260 1415.25 224 1387.25 144 1365.25 77 1351.25 54 1333.25 48 1317.25 34 1298.25 27 1279.25 38 1258.25 58 1239.25 71 1222.25 72 1214.25 59 1205.25 41 1187.25 45 1169.25 97 1150.25 159 1142.25 180 1147.25 209 1148.25 231 1139.25 256 1139.25 325 1135.25 349 1113.25 385 1113.25 411 1107.25 425 1089.25 431 1084.17 435.62'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='ME'
				className={`polygon ${selectedState === 'ME' ? 'selected' : ''}`}
				onClick={() => handleStateClick('ME')}
			/>
			<polygon
				id='PA'
				points='803.25 1436 827.25 1413 835.25 1394 869.25 1356 809.25 1302 800 1282.07 807.25 1257 798.25 1234 812.25 1212 815.25 1187 829.25 1165 796.25 1149.08 777.25 1123 737.25 1084 720.25 1083 532.25 1126 278.25 1177 211.3 1188.64 211.3 1134.37 161.25 1177 127.74 1198.32 190.25 1568 483.25 1513 662.25 1477 732.25 1460 763.25 1455 771.25 1432 796.25 1421 803.25 1436'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='PA'
				className={`polygon ${selectedState === 'PA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('PA')}
			/>
			<rect x='350.25' y='1344' width='241' height='47' fill='none' className='shape' />
			<path
				d='M420.27,1356.02l-1.96,10.23h11.16l1.96-10.23h2.99l-4.62,24.26h-2.99l2.15-11.4h-11.16l-2.15,11.4h-2.98l4.61-24.26h2.98Z'
				className='shape'
			/>
			<path
				d='M449.56,1380.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM451.5,1365.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M459.76,1380.28l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.49,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M474.05,1380.28l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M488.34,1380.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM492.22,1358.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M499.61,1377.26c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.01-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.11,1.13-3.11,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M523.45,1354.72l-2.3,11.3.07.02c1.55-2.35,3.78-3.56,6.12-3.56,3.82,0,5.27,3.15,5.27,6.24,0,5.36-3.87,11.96-10.85,11.96-3.07,0-5.37-1.28-5.36-4.49,0-.85.14-1.87.3-2.7l3.75-18.76h2.99ZM519.67,1373.55c-.12.59-.23,1.28-.21,2.21.02,1.66.96,2.57,2.82,2.57,4.51,0,7.23-5.36,7.23-9.22,0-2.16-.94-4.15-3.32-4.15-2.57,0-5.25,2.67-6.12,6.74l-.39,1.85Z'
				className='shape'
			/>
			<path
				d='M554.53,1362.87l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.33-2.93l1.88-9.83h2.98l-1.85,9.7c-.19.97-.3,1.8-.3,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path
				d='M559.37,1380.28l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M573.56,1384.23c1.06.67,2.79,1.14,4.62,1.14,2.93,0,5.23-1.49,6.26-6.2l.58-2.6h-.09c-1.53,2.49-3.65,3.7-6.05,3.7-3.5,0-5.3-2.94-5.3-6.03-.01-5.93,4.31-11.76,11.05-11.76,2.02,0,4.22.56,5.59,1.21l-2.67,14.39c-.7,3.69-1.7,6.23-3.51,7.79-1.74,1.51-4.09,1.93-6.08,1.93-2.12,0-4.13-.49-5.22-1.23l.83-2.34ZM586.94,1365.46c-.55-.27-1.63-.59-2.88-.59-4.36,0-7.36,4.56-7.38,8.85-.01,1.93.68,4.17,3.34,4.17s5.16-3.24,5.81-6.63l1.11-5.8Z'
				className='shape'
			/>
			<polygon
				points='616.92 1389.08 617.29 1404 632.98 1404 617.52 1413.22 617.89 1428.15 607.96 1418.92 592.5 1428.15 601.83 1413.22 591.9 1404 607.59 1404 616.92 1389.08'
				className='shape'
			/>
			<rect x='879.67' y='1371' width='173.58' height='40' fill='none' className='shape' />
			<path
				d='M889.11,1382.11h-7.09l.51-2.59h17.18l-.5,2.59h-7.12l-4.11,21.67h-2.98l4.11-21.67Z'
				className='shape'
			/>
			<path
				d='M898.8,1403.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M925.47,1402.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM922.17,1388.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M932.1,1403.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M962,1381.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M984.91,1393.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM971.53,1396.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M989.88,1403.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='872.92 1343.08 873.29 1358 888.98 1358 873.52 1367.22 873.89 1382.15 863.96 1372.92 848.5 1382.15 857.83 1367.22 847.9 1358 863.59 1358 872.92 1343.08'
				className='shape'
			/>
			<rect x='704.25' y='969' width='161.42' height='38' fill='none' className='shape' />
			<path
				d='M755.94,993.11l-3.86,7.67h-3.14l12.53-24.26h3.53l3.35,24.26h-3.06l-.98-7.67h-8.37ZM764.09,990.73l-.94-7.01c-.13-1.26-.31-3.04-.43-4.46h-.08c-.65,1.45-1.25,2.96-1.99,4.42l-3.62,7.05h7.06Z'
				className='shape'
			/>
			<path d='M774.29,1000.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M793.08,975.22l-2.3,11.3.07.02c1.55-2.35,3.78-3.56,6.12-3.56,3.82,0,5.27,3.15,5.27,6.24,0,5.36-3.87,11.96-10.85,11.96-3.07,0-5.37-1.28-5.36-4.49,0-.85.14-1.87.3-2.7l3.75-18.76h2.99ZM789.31,994.05c-.12.59-.23,1.28-.21,2.21.02,1.66.96,2.57,2.82,2.57,4.51,0,7.23-5.36,7.23-9.22,0-2.16-.94-4.15-3.32-4.15-2.57,0-5.25,2.67-6.13,6.74l-.39,1.85Z'
				className='shape'
			/>
			<path
				d='M818.73,1000.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM820.67,985.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M828.93,1000.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M854.62,983.37l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.57c.75-.26,2.01-.75,3.19-1.67,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<polygon
				points='893.92 937.08 894.29 952 909.98 952 894.52 961.22 894.89 976.15 884.96 966.92 869.5 976.15 878.83 961.22 868.9 952 884.59 952 893.92 937.08'
				className='shape'
			/>
			<rect x='825.67' y='1065' width='198.58' height='38' fill='none' className='shape' />
			<path
				d='M888.7,1072.52l-1.96,10.23h11.16l1.95-10.23h2.99l-4.62,24.26h-2.99l2.15-11.4h-11.16l-2.15,11.4h-2.98l4.61-24.26h2.98Z'
				className='shape'
			/>
			<path
				d='M917.98,1096.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM919.92,1081.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M928.18,1096.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M951.24,1074.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M958,1096.78l2.86-15.06h-2.32l.45-2.34h2.33l.17-.93c.43-2.42,1.29-4.66,2.85-6.07,1.1-.99,2.62-1.54,4.13-1.54,1.2,0,1.98.23,2.39.47l-.65,2.39c-.46-.22-1.07-.34-1.75-.34-2.37,0-3.53,2.32-4.04,5.19l-.15.83h3.88l-.46,2.34h-3.87l-2.86,15.06h-2.96Z'
				className='shape'
			/>
			<path
				d='M987.3,1086.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM973.91,1089.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M992.26,1096.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1024.89,1071.22l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM1019.88,1082.1c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<polygon
				points='1065.92 1043.08 1066.29 1058 1081.98 1058 1066.52 1067.22 1066.89 1082.15 1056.96 1072.92 1041.5 1082.15 1050.83 1067.22 1040.9 1058 1056.59 1058 1065.92 1043.08'
				className='shape'
			/>
			<rect x='940.67' y='960' width='251.58' height='56' fill='none' className='shape' />
			<path
				d='M1014.11,976.88c1.36-.32,3.3-.52,5.26-.52,2.34,0,4.59.56,5.95,1.87,1.15,1.06,1.76,2.48,1.76,4.39,0,2.71-1.33,4.99-2.91,6.31-1.87,1.58-4.62,2.32-7.35,2.32-.91,0-1.71-.06-2.47-.19l-1.85,9.72h-2.94l4.55-23.9ZM1014.81,988.54c.85.18,1.54.24,2.42.24,4.09,0,6.84-2.54,6.84-5.96,0-2.9-2.06-4.04-4.83-4.04-1.18,0-2.08.1-2.61.26l-1.81,9.5Z'
				className='shape'
			/>
			<path
				d='M1030.2,1000.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1061.01,990.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1047.63,993.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1069.6,983.37l1.5,9.91c.26,1.98.49,3.32.56,4.28h.1c.38-.92.85-2.07,1.86-4.05l5.31-10.13h3.27l-9.69,17.41h-2.94l-3.01-17.41h3.04Z'
				className='shape'
			/>
			<path
				d='M1084.99,1000.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1088.86,978.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1114.63,975.22l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM1109.62,986.1c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<path
				d='M1130.45,999.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1127.14,985.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1137.08,1000.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1171.16,1000.09c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M1189.52,999.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1186.22,985.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='1214.92 1002.08 1215.29 1017 1230.98 1017 1215.52 1026.22 1215.89 1041.15 1205.96 1031.92 1190.5 1041.15 1199.83 1026.22 1189.9 1017 1205.59 1017 1214.92 1002.08'
				className='shape'
			/>
			<rect x='688.25' y='632' width='254.42' height='39' fill='none' className='shape' />
			<path
				d='M781.28,664.28l1.74-13.1c.31-2.31.85-5.87,1.31-8.21h-.11c-1.12,2.45-2.47,5.33-3.8,7.82l-7.21,13.34h-2.28l-1.79-13.07c-.37-2.79-.62-5.6-.78-8.09h-.08c-.51,2.24-1.27,5.91-1.85,8.22l-3.3,13.09h-2.81l6.28-24.26h3.81l1.92,13.91c.24,2.06.52,4.28.58,6.08h.11c.74-1.8,1.78-3.98,2.82-6l7.51-14h3.9l-3.08,24.26h-2.91Z'
				className='shape'
			/>
			<path
				d='M808.52,653.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM795.13,657.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M813.49,664.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M843.38,642.19l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M848.17,671.41l3.49-18.36c.39-2.09.75-4.42.98-6.17h2.73l-.49,3.28h.07c1.58-2.3,3.88-3.67,6.26-3.67,3.77,0,5.36,3.1,5.36,6.29,0,6.13-4.4,11.91-10.2,11.91-1.85,0-3.08-.41-3.75-.78h-.07l-1.41,7.51h-2.97ZM853.07,661.36c.77.6,1.9.96,3.32.96,3.85,0,7.07-4.78,7.07-9.33,0-1.83-.81-4.03-3.34-4.03-2.35,0-5.27,2.67-6.17,7.54l-.88,4.86Z'
				className='shape'
			/>
			<path
				d='M884.18,663.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM880.88,648.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path d='M890.82,664.28l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M901.94,664.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM905.81,642.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M925.61,663.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM922.31,648.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M932.25,664.28l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<polygon
				points='970.92 659.08 971.29 674 986.98 674 971.52 683.22 971.89 698.15 961.96 688.92 946.5 698.15 955.83 683.22 945.9 674 961.59 674 970.92 659.08'
				className='shape'
			/>
			<rect x='910.25' y='773' width='191.42' height='38' fill='none' className='shape' />
			<path
				d='M928.14,804c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M950.59,794.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM937.2,797.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M955.55,804.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M989.63,804.09c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M1012.15,794.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM998.76,797.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1017.11,804.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1049.74,779.22l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM1044.73,790.1c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<polygon
				points='1133.92 789.08 1134.29 804 1149.98 804 1134.52 813.22 1134.89 828.15 1124.96 818.92 1109.5 828.15 1118.83 813.22 1108.9 804 1124.59 804 1133.92 789.08'
				className='shape'
			/>
			<polygon
				points='1282.92 558.08 1283.29 573 1298.98 573 1283.52 582.22 1283.89 597.15 1273.96 587.92 1258.5 597.15 1267.83 582.22 1257.9 573 1273.59 573 1282.92 558.08'
				className='shape'
			/>
			<text
				fill='#000000'
				fontFamily='Arial'
				fontSize='34'
				fontStyle='italic'
				id='svg_1'
				stroke='#000000'
				strokeWidth='0'
				textAnchor='middle' x='1362' xmlSpace='preserve' y='555'>Augusta</text>
			<path
				d='M1256.33,950.86c1.48-.3,3.23-.5,5.2-.5,2.5,0,4.31.5,5.6,1.66,1.12.91,1.74,2.2,1.74,3.78,0,3.07-2.47,5.34-5.22,6.05v.1c2.19.64,4,2.46,3.98,5.38,0,2.48-1.32,4.43-2.9,5.62-1.93,1.44-4.6,1.99-7.85,1.99-2.08,0-3.89-.13-5.03-.34l4.49-23.74ZM1255.19,972.37c.76.12,1.64.16,2.45.16,3.53.02,6.85-1.46,6.85-5.34,0-2.85-2.4-4.1-5.12-4.1h-2.43l-1.75,9.28ZM1257.41,960.81h2.22c3.48,0,6.16-1.8,6.16-4.75,0-2.34-1.76-3.33-4.4-3.33-1.1,0-2.01.08-2.48.22l-1.5,7.86Z'
				className='shape'
			/>
			<path
				d='M1290.07,964.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1276.68,967.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1295.18,971.76c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1319.14,952.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M1342.05,964.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1328.67,967.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1347.02,974.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='1237.92 915.08 1238.29 930 1253.98 930 1238.52 939.22 1238.89 954.15 1228.96 944.92 1213.5 954.15 1222.83 939.22 1212.9 930 1228.59 930 1237.92 915.08'
				className='shape'
			/>
			<rect
				x='1220.57'
				y='315.67'
				width='216.68'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1256.31,363.61l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M1293.11,363.61c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1296.34,338.3c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1310.11,363.61l5.54-29.02h4.96l-5.54,29.02h-4.97ZM1316.57,326.49c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.3,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1328.65,363.61l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1386.42,361.95c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1380.91,337.8c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<rect
				x='1051.82'
				y='700.67'
				width='530.44'
				height='58.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M1053.69,751.13l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M1117.16,749.47c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1111.66,725.33c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1135.27,722.12l1.02,16.32c.22,3.59.2,5.45.14,7.81h.13c.69-1.89,1.74-4.38,3.19-7.28l8.63-16.84h4.33l1.83,16.53c.3,3.19.49,5.66.46,7.59h.15c.77-2.34,1.57-4.58,2.74-7.36l7.83-16.76h5.07l-14.34,29.02h-4.62l-1.92-15.76c-.29-2.69-.44-5.16-.42-7.72h-.12c-1.22,2.79-2.05,5-3.37,7.58l-8.32,15.91h-4.65l-2.68-29.02h4.91Z'
				className='shape'
			/>
			<path
				d='M1204.18,710.7l-3.27,17.06h18.6l3.26-17.06h4.99l-7.7,40.44h-4.98l3.59-19h-18.61l-3.59,19h-4.96l7.69-40.44h4.98Z'
				className='shape'
			/>
			<path
				d='M1253,751.13c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1256.22,725.83c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1269.99,751.13l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M1320.66,763.01l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM1328.82,746.27c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M1359.82,746.09c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1386.75,751.13l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.96l3.18-16.76c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.96Z'
				className='shape'
			/>
			<path
				d='M1423.59,751.13l5.54-29.02h4.96l-5.54,29.02h-4.96ZM1430.05,714.02c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.3,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1442.13,751.13l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M1486.58,749.47c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1481.08,725.33c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<rect
				x='725.82'
				y='555.67'
				width='287.44'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M735.82,603.61l-4.99-40.44h5.08l2.94,25.89c.46,4.18.72,6.48.77,9.16h.17c1.02-2.51,2.25-5.53,4.44-9.77l12.88-25.28h5.48l-21.27,40.44h-5.5Z'
				className='shape'
			/>
			<path
				d='M783.78,601.95c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM778.28,577.81c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M794.84,603.61l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M818.66,603.61l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M899.78,586c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM877.47,592.16c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.33,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M908.06,603.61l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M957.89,566.8l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.74.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.45l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<rect
				x='448.72'
				y='957.04'
				width='311.53'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M450.59,1004.98l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M514.07,1003.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM508.56,979.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M532.17,975.97l1.02,16.32c.22,3.59.2,5.45.14,7.81h.13c.69-1.89,1.74-4.38,3.19-7.28l8.63-16.84h4.33l1.83,16.53c.3,3.19.49,5.66.46,7.59h.15c.77-2.34,1.57-4.58,2.74-7.36l7.83-16.76h5.07l-14.34,29.02h-4.62l-1.92-15.76c-.29-2.69-.44-5.16-.42-7.72h-.12c-1.22,2.79-2.05,5-3.37,7.58l-8.32,15.91h-4.65l-2.68-29.02h4.91Z'
				className='shape'
			/>
			<path
				d='M596.16,1004.98l3.21-16.8-7.8-23.64h5.31l3.91,13.1c1.03,3.56,1.42,5.2,1.72,6.75h.12c.98-1.67,2.37-3.95,4.32-6.95l8.74-12.9h5.83l-17.21,23.6-3.18,16.84h-4.98Z'
				className='shape'
			/>
			<path
				d='M647.76,987.37c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM625.45,993.53c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.33,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M656.04,1004.98l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M679.87,1004.98l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<rect
				x='999.72'
				y='1109.04'
				width='418.53'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1029.54,1155.67c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.67-7.95-1.67-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M1066.95,1139.37c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1044.63,1145.53c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.33,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1075.22,1156.98l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1112.06,1156.98l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1169.83,1155.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1164.32,1131.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1200.9,1155.83c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M1224.47,1120.17l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.74.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.45l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1235.06,1156.98l5.54-29.02h4.96l-5.54,29.02h-4.97ZM1241.52,1119.87c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.3,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1273.56,1155.83c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M1312.08,1127.97l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.44h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M1333.12,1120.17l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.74.82,2.81,2.75,2.81.89,0,1.7-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.45l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<rect
				x='885.72'
				y='1291.04'
				width='375.53'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M887.59,1338.98l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M951.07,1337.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM945.56,1313.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M969.17,1309.97l1.02,16.32c.22,3.59.2,5.45.14,7.81h.13c.69-1.89,1.74-4.38,3.19-7.28l8.63-16.84h4.33l1.83,16.53c.3,3.19.49,5.66.46,7.59h.15c.77-2.34,1.57-4.58,2.74-7.36l7.83-16.76h5.07l-14.34,29.02h-4.62l-1.92-15.76c-.29-2.69-.44-5.16-.42-7.72h-.12c-1.22,2.79-2.05,5-3.37,7.58l-8.32,15.91h-4.65l-2.68-29.02h4.91Z'
				className='shape'
			/>
			<path
				d='M1022.76,1334.34c1.32.56,2.95.88,5.09.88,4.24,0,6.94-2.24,8.28-9.4l5.18-27.28h4.96l-5.28,27.83c-1.78,9.47-5.73,13.27-13.31,13.27-2.44,0-4.98-.52-6-1.05l1.08-4.25Z'
				className='shape'
			/>
			<path
				d='M1072.98,1337.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1067.48,1313.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1084.04,1338.98l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M1108.16,1333.94c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1156.02,1337.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1150.52,1313.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1173.59,1309.97l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.9,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.26-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<rect
				x='1134.72'
				y='865.04'
				width='477.53'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1170.46,912.98l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M1207.26,912.98c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1210.49,887.68c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1224.5,907.94c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1251.68,907.94c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1297.86,912.98c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1301.09,887.68c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1334.7,911.83c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M1344.92,912.98l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.76c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M1409.76,883.97l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.44h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M1418.06,907.94c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1465.92,911.32c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1460.42,887.18c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1489.96,876.17l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.74.82,2.81,2.75,2.81.89,0,1.7-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.45l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1513.54,876.17l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.74.82,2.81,2.75,2.81.89,0,1.7-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.45l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
      <path
				d='M1523.72,907.94c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<rect
				x='1162.46'
				y='1042.93'
				width='442.79'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1171.93,1051.03c2.47-.56,5.81-.86,8.82-.86,4.04,0,7.5.95,9.66,2.93,1.87,1.62,2.99,3.94,2.99,6.7,0,5.87-4.5,10.26-9.6,11.69v.15c2.81.94,4.15,3.97,4.45,8.12.45,5.64.73,9.5,1.26,11.12h-5.15c-.23-.86-.65-5.09-.94-9.75-.32-5.57-2.36-7.86-6.38-7.86h-4.42l-3.34,17.62h-4.93l7.58-39.84ZM1173.38,1069.39h4.46c6.31,0,10.37-4.12,10.37-8.97,0-4.33-3.26-6.27-7.81-6.27-1.99,0-3.26.17-4.19.43l-2.82,14.81Z'
				className='shape'
			/>
			<path
				d='M1200.82,1090.87l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.76c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M1265.51,1073.26c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1243.19,1079.42c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.33,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1304.82,1048.28l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM1296.47,1066.4c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<path
				d='M1331.19,1089.21c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1325.69,1065.07c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path d='M1370.73,1050.43l-7.7,40.44h-4.97l7.69-40.44h4.98Z' className='shape' />
			<path
				d='M1376.92,1085.83c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path d='M1403.87,1090.87l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M1441.64,1090.87c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1444.87,1065.57c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1458.64,1090.87l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1526.34,1048.28l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM1517.99,1066.4c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<rect
				x='350.68'
				y='1236.79'
				width='375.57'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M360.14,1244.89c2.27-.53,5.5-.86,8.76-.86,3.9,0,7.65.94,9.91,3.11,1.91,1.77,2.93,4.13,2.93,7.32,0,4.51-2.21,8.31-4.84,10.52-3.12,2.63-7.7,3.87-12.25,3.87-1.52,0-2.84-.11-4.12-.32l-3.08,16.21h-4.89l7.59-39.84ZM361.3,1264.33c1.41.3,2.56.4,4.03.4,6.82,0,11.4-4.24,11.4-9.93,0-4.83-3.44-6.73-8.05-6.73-1.97,0-3.46.17-4.36.43l-3.02,15.83Z'
				className='shape'
			/>
			<path
				d='M407.39,1283.07c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.67,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM401.88,1258.93c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M418.44,1284.73l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M455.28,1284.73l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M492.36,1279.69c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M525.63,1255.72l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.9,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.26-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<path d='M550.57,1284.73l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M575.61,1255.72l2.5,16.52c.44,3.3.81,5.54.93,7.13h.17c.64-1.54,1.41-3.45,3.09-6.76l8.86-16.89h5.45l-16.15,29.02h-4.9l-5.01-29.02h5.07Z'
				className='shape'
			/>
			<path
				d='M619.48,1284.73c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM622.7,1259.43c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M636.47,1284.73l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M673.31,1284.73l5.54-29.02h4.97l-5.54,29.02h-4.97ZM679.78,1247.61c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.3,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M711.09,1284.73c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM714.32,1259.43c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
		</svg>
	);
};

NortheastMap.propTypes = {
	onStateClick: PropTypes.func.isRequired,
	selectedState: PropTypes.string,
};

export default NortheastMap;
